import { LineChart } from '@mui/x-charts';
import {
  IParticipantModel,
  useGetAdminCompetitionItemParticipantsQuery,
  useGetAdminCompetitionItemStatsQuery,
} from 'entities/competitions-b2b';
import React, { FC, useEffect, useRef, useState } from 'react';
import { CircularLoader } from 'shared/ui/CircularLoader/CircularLoader';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/system';
import { ICompetitionStatsWidget } from './types';
import { DataTableFrontendPagination } from '../../../shared/ui/Table';
import { fieldsBannerConfig } from './model';
import { getDate } from '../../../shared/utils/date';
import { ShortPresentationItem } from '../ShortPresentationItem';
import { compareTwoDates } from '../../../shared/helpers/compareTwoDates';

const CompetitionStatsWidget: FC<ICompetitionStatsWidget> = ({ id, participantsCount, dateAwardEnd }) => {
  const navigate = useNavigate();
  const { data, isLoading } = useGetAdminCompetitionItemStatsQuery({ competition_id: id });
  const [width, setWidth] = useState(0);
  const elementRef = useRef<HTMLDivElement>(null);
  const { data: participants } = useGetAdminCompetitionItemParticipantsQuery({ competition_id: id });
  const purchaseSum = data?.reduce((accum, curr) => accum + Number(curr.purchase_amount), 0);
  const dateCompared = compareTwoDates(new Date(), new Date(dateAwardEnd));

  useEffect(() => {
    if (!elementRef.current) return;
    setWidth(elementRef.current.getBoundingClientRect().width);
  }, [data]);

  if (isLoading) return <CircularLoader />;

  if (!data) return <div>При получении данных произошла ошибка</div>;

  return (
    <div
      ref={elementRef}
      style={{ width: '100%' }}
    >
      <div style={{ padding: 16 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '80%', mb: 3 }}>
          <ShortPresentationItem
            title="Кол-во участников (ТТ)"
            value={`${participantsCount} участника` ?? 'Нет участников'}
          />
          <ShortPresentationItem
            title="Время до конца соревнования"
            value={dateCompared > 0 ? `${dateCompared} дня` : 'Соревнование окончено'}
          />
          <ShortPresentationItem
            title="Общая сумма продаж"
            value={purchaseSum?.toString() || '---'}
          />
        </Box>
      </div>
      {width && data && data.length ? (
        <LineChart
          disableAxisListener
          sx={{
            '.MuiLineElement-root': {
              stroke: '#2330C5',
              strokeWidth: 2,
            },
            '.MuiMarkElement-root': {
              stroke: '#2330C5',
              strokeWidth: 2,
              // scale: '0.6',
            },
            '.MuiChartsAxis-root': {},
            '.MuiChartsAxis-tickLabel': {
              display: 'none',
            },
            '.MuiChartsAxis-tick .MuiChartsAxis-tickContainer': {},
          }}
          xAxis={[{ data: data.map((item) => item.day) }] || [0]}
          series={[
            {
              data: data.map((item) => item.purchase_amount) || [0],
            },
          ]}
          width={width ? width - 40 : 0}
          height={300}
        />
      ) : null}
      <DataTableFrontendPagination<IParticipantModel>
        title="Таблица закупок ТТ"
        data={participants?.items.map((item) => ({ ...item, created_at: getDate(item.created_at) })) || []}
        onRowClick={(row) => navigate(`salePoint/${row}`)}
        columnConfig={fieldsBannerConfig}
      />
    </div>
  );
};

export { CompetitionStatsWidget };
